import * as React from 'react';
import { ComponentLayout } from 'src/components/common/modules/component-layout/code-split/component-layout-component';
import Layout from 'src/components/common/modules/component-layout/component-layout';
import { ComponentLayoutType } from 'src/components/common/modules/component-layout/component-layout';
import { V2TextModuleComponent } from './code-split/v2-text-module-component';

// Css Style Import
import(
  /* webpackChunkName: "v2-text-module-styles" */ 'src/components/common/modules/v2/v2-text-module/styles/v2-text-module.css'
);

const V2TextModule: React.FC<ComponentLayoutType<any>> = (props) => {
  if (props?.data?.withoutCodeSplit) {
    return (
      <Layout {...props}>
        <V2TextModuleComponent />
      </Layout>
    );
  }
  return (
    <ComponentLayout {...props}>
      <V2TextModuleComponent />
    </ComponentLayout>
  );
};

export default V2TextModule;
